export interface IApiEligibleCategories {
  type: 'eligibleCategories';
  id: string;
  attributes: {
    categories: ICategory[];
  };
}

export enum ECategoryType {
  COMMAND = 'COMMAND',
  NRC_INCOGNITO = 'NRC_INCOGNITO',
  PASS = 'PASS',
}

export interface ICategory {
  id: ECategoryType;
  specialOffers?: ISpecialOffer[];
}

export interface IPassCategory extends ICategory {
  id: ECategoryType.PASS;
  specialOffers: ISpecialOffer[];
}

export enum ESpecialOfferType {
  AGGRESSIVE_PROMO = 'AGGRESSIVE_PROMO',
  'PERCENTAGE_LIST-50' = 'PERCENTAGE_LIST-50',
  'PERCENTAGE_LIST-30' = 'PERCENTAGE_LIST-30',
}

export interface ISpecialOffer {
  type: ESpecialOfferType;
  startDate: string;
  endDate: string;
}
